module.exports = __webpack_public_path__ + "static/media/emotional.4ad95a1e.svg";